<template>
  <div class="experience-page-container" v-cloak>
    <nav-bar model="blue"></nav-bar>
    <banner></banner>
    <experience-content></experience-content>
    <customize></customize>
    <page-footer></page-footer>
  </div>
</template>

<script>
import navBar from "../common/navBar";
import banner from "./components/banner";
import experienceContent from "./components/experienceContent";
import customize from "../common/customize";
import pageFooter from "../common/pageFooter";
export default {
  components: {
    navBar,
    banner,
    experienceContent,
    customize,
    pageFooter,
  },
  data() {
    return {};
  },
  mounted() {
    new this.$wow.WOW({
      mobile: false,
      live: false,
    }).init();
  },
};
</script>

<style lang="scss" scoped>
.experience-page-container {
}
</style>



// WEBPACK FOOTER //
// src/view/experience/experience.vue